var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function copyToClipboard(text) {
    // 创建一个隐藏的输入元素
    var input = document.createElement('input');
    // 设置输入元素的值为要复制的文本
    input.value = text;
    // 将输入元素添加到文档中
    document.body.appendChild(input);
    // 选择输入元素的内容
    input.select();
    // 执行复制命令
    document.execCommand('copy');
    // 移除输入元素
    document.body.removeChild(input);
}
var DEFAULT_OSS_IMAGE_ORIGIN = 'https://img.danachatapp.com';
var OSS_IMAGE_HOST_PREFIX = 'img.';
var OSS_PROCESS_PARAM = 'x-oss-process';
var DEFAULT_OSS_QUALITY = 30;
function normalizeQuality(quality, fallback) {
    if (fallback === void 0) { fallback = DEFAULT_OSS_QUALITY; }
    var parsed = Number(quality);
    if (!Number.isFinite(parsed)) {
        return fallback;
    }
    return Math.min(100, Math.max(1, Math.round(parsed)));
}
function isGifPath(pathname) {
    var extMatch = pathname.toLowerCase().match(/\.([a-z0-9]+)$/);
    var ext = (extMatch === null || extMatch === void 0 ? void 0 : extMatch[1]) || '';
    return ext === 'gif';
}
/**
 * 构建 OSS 图片 URL（仅质量参数）
 * 默认质量 q_30，可按需覆盖。
 */
export function buildOssImageUrl(url, quality) {
    if (quality === void 0) { quality = DEFAULT_OSS_QUALITY; }
    if (!url || typeof url !== 'string') {
        return url;
    }
    var parsedUrl;
    try {
        parsedUrl = new URL(url);
    }
    catch (error) {
        return url;
    }
    if (!parsedUrl.hostname.startsWith(OSS_IMAGE_HOST_PREFIX)) {
        return url;
    }
    var runtimeOrigin = resolveRuntimeImageOrigin();
    if (runtimeOrigin) {
        var runtimeUrl = new URL(runtimeOrigin);
        parsedUrl.protocol = runtimeUrl.protocol;
        parsedUrl.host = runtimeUrl.host;
    }
    if (isGifPath(parsedUrl.pathname)) {
        return parsedUrl.toString();
    }
    var normalizedQuality = normalizeQuality(quality);
    var processValue = "image/quality,q_".concat(normalizedQuality);
    parsedUrl.searchParams.set(OSS_PROCESS_PARAM, processValue);
    return parsedUrl.toString();
}
/**
 * 图片域名固定使用 img.danachatapp.com
 */
export function resolveRuntimeImageOrigin(currentHref) {
    void currentHref;
    return DEFAULT_OSS_IMAGE_ORIGIN;
}
export function applyRuntimeImageOriginCssVar(origin) {
    var finalOrigin = origin || resolveRuntimeImageOrigin();
    if (typeof document !== 'undefined') {
        document.documentElement.style.setProperty('--dana-img-origin', finalOrigin);
    }
    return finalOrigin;
}
function escapeCssClassName(value) {
    return value.replace(/([^a-zA-Z0-9_-])/g, '\\$1');
}
function normalizeManifestUrl(urlOrPath, origin) {
    if (!urlOrPath) {
        return '';
    }
    if (urlOrPath.startsWith('/')) {
        return "".concat(origin).concat(urlOrPath);
    }
    try {
        var parsed = new URL(urlOrPath);
        if (parsed.hostname.startsWith(OSS_IMAGE_HOST_PREFIX)) {
            var runtimeOrigin = new URL(origin);
            parsed.protocol = runtimeOrigin.protocol;
            parsed.host = runtimeOrigin.host;
            return parsed.toString();
        }
        return urlOrPath;
    }
    catch (error) {
        return urlOrPath;
    }
}
/**
 * 通过 bg 清单注入覆盖样式，避免遍历整份 CSSOM。
 */
export function applyBgImageManifestOverrides(bgManifest, targetOrigin) {
    var finalOrigin = targetOrigin || resolveRuntimeImageOrigin();
    if (typeof document === 'undefined' || !bgManifest || typeof bgManifest !== 'object') {
        return finalOrigin;
    }
    var styleId = 'dana-runtime-bg-overrides';
    var styleEl = document.getElementById(styleId);
    if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = styleId;
        document.head.appendChild(styleEl);
    }
    var rules = Object.entries(bgManifest)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        var normalizedUrl = normalizeManifestUrl(String(value || ''), finalOrigin);
        if (!normalizedUrl) {
            return '';
        }
        var className = escapeCssClassName(key);
        return ".bg-".concat(className, "{background-image:url(\"").concat(normalizedUrl, "\") !important;}");
    })
        .filter(Boolean)
        .join('\n');
    styleEl.textContent = rules;
    return finalOrigin;
}
// export function _T(txt: string) {
//     const lan = getArgFromUrl('language')
//     const l: any = lan === 'en' ? langEn : lang
//     return l[txt]
// }
export function sprintf(txt, obj) {
    var result = txt;
    Object.keys(obj).forEach(function (key) {
        result = result.replace("{".concat(key, "}"), obj[key]);
    });
    return result;
}
export function getArgFromUrl(name) {
    var url = window.location.href;
    // 检查URL中是否包含哈希路由
    if (url.includes('#/')) {
        // 处理哈希路由后的查询参数
        var hashPart = url.split('#/')[1];
        var hashPart2 = url.split('#/')[0];
        if (hashPart && hashPart.includes('?')) {
            var queryString = hashPart.split('?')[1];
            var params = new URLSearchParams(queryString);
            return params.get(name);
        }
        if (hashPart2 && hashPart2.includes('?')) {
            var queryString = hashPart2.split('?')[1];
            var params = new URLSearchParams(queryString);
            return params.get(name);
        }
        return null;
    }
    else {
        // 处理常规查询参数
        var urlObj = new URL(url);
        var params = new URLSearchParams(urlObj.search);
        return params.get(name);
    }
}
export function jumpWithCurrentParams(path) {
    if (!path) {
        return;
    }
    var mergedParams = new URLSearchParams(window.location.search);
    var hash = window.location.hash || '';
    var hashQueryIndex = hash.indexOf('?');
    if (hashQueryIndex >= 0) {
        var hashParams = new URLSearchParams(hash.slice(hashQueryIndex + 1));
        hashParams.forEach(function (value, key) {
            if (!mergedParams.has(key)) {
                mergedParams.set(key, value);
            }
        });
    }
    var targetUrl = new URL(path, window.location.origin);
    mergedParams.forEach(function (value, key) {
        targetUrl.searchParams.set(key, value);
    });
    window.location.href = targetUrl.toString();
}
export function formaTimeForTsToH(time) {
    return (time / 1000 / 60 / 60).toFixed(2) + 'H';
}
export function formatScore(num) {
    if (num > 999999999) {
        return '999.9M+';
    }
    if (num >= 1000000) {
        return (Math.floor(num / 100000) / 10).toFixed(1) + 'M';
    }
    if (num >= 1000) {
        return (Math.floor(num / 100) / 10).toFixed(1) + 'k';
    }
    // 如果有小数，保留1位
    if (num % 1 !== 0) {
        return num.toFixed(1);
    }
    return String(num);
}
export function formatScoreComma(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
export function getStatusBarHeight() {
    return new Promise(function (resolve) {
        window.addEventListener('fromFlutter', function (event) {
            var _a = event.detail, method = _a.method, height = _a.height;
            resolve(height);
        });
        if (window.toFlutter) {
            window.toFlutter.postMessage(JSON.stringify({ method: 'getStatusBarHeight' }));
        }
        setTimeout(function () {
            resolve(0);
        }, 100);
    });
}
export function isNumber(value) {
    var regex = /^[+-]?\d+(\.\d+)?$/;
    return regex.test(value);
}
export function setViewport() {
    var designWidth = 375;
    var maxRetryCount = 30;
    var retryDelay = 120;
    var resizeDebounce = 100;
    var win = window;
    var measureViewportWidth = function () {
        var _a;
        var visualWidth = ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.width) || 0;
        var innerWidth = window.innerWidth || 0;
        var clientWidth = document.documentElement.clientWidth || 0;
        return visualWidth || innerWidth || clientWidth;
    };
    var inferWidthFromMeta = function () {
        var viewportMeta = document.querySelector('meta[name="viewport"]');
        var content = (viewportMeta === null || viewportMeta === void 0 ? void 0 : viewportMeta.getAttribute('content')) || '';
        if (!content.includes('width=375')) {
            return 0;
        }
        var match = content.match(/(?:^|[,\s])initial-scale=([0-9.]+)/);
        var scale = Number((match === null || match === void 0 ? void 0 : match[1]) || '');
        if (!Number.isFinite(scale) || scale <= 0) {
            return 0;
        }
        return designWidth * scale;
    };
    var resolveBaseWidth = function (state) {
        if (state.baseWidth > 0) {
            return state.baseWidth;
        }
        var inferredWidth = inferWidthFromMeta();
        if (inferredWidth > 0) {
            state.baseWidth = inferredWidth;
            return inferredWidth;
        }
        var measuredWidth = measureViewportWidth();
        if (measuredWidth > 0) {
            state.baseWidth = measuredWidth;
            return measuredWidth;
        }
        return 0;
    };
    var setScale = function (state) {
        var width = resolveBaseWidth(state);
        if (width <= 0) {
            return false;
        }
        var scale = Number((width / designWidth).toFixed(4));
        var viewportMeta = document.querySelector('meta[name="viewport"]');
        var content = "width=375, initial-scale=".concat(scale, ", maximum-scale=").concat(scale, ", user-scalable=no");
        if (state.lastContent === content) {
            return true;
        }
        if (viewportMeta) {
            viewportMeta.setAttribute('content', content);
        }
        else {
            var meta = document.createElement('meta');
            meta.name = 'viewport';
            meta.content = content;
            document.head.appendChild(meta);
        }
        state.lastContent = content;
        // Prevent immediate self-trigger loops from resize/pageshow events caused by viewport updates.
        state.suppressUntil = Date.now() + 180;
        return true;
    };
    var setScaleWithRetry = function (state, retryCount) {
        if (retryCount === void 0) { retryCount = 0; }
        if (setScale(state) || retryCount >= maxRetryCount) {
            return;
        }
        window.setTimeout(function () { return setScaleWithRetry(state, retryCount + 1); }, retryDelay);
    };
    if (win.__danaViewportState__) {
        win.__danaViewportState__.trigger();
        return;
    }
    var state = {
        resizeTimer: null,
        baseWidth: 0,
        lastContent: '',
        suppressUntil: 0,
        trigger: function () { return setScaleWithRetry(state); },
    };
    var onResize = function () {
        if (Date.now() < state.suppressUntil) {
            return;
        }
        var measuredWidth = measureViewportWidth();
        // If viewport gives a real device width (> designWidth), refresh base width; ignore transformed 375.
        if (measuredWidth > designWidth + 1 && Math.abs(measuredWidth - state.baseWidth) > 1) {
            state.baseWidth = measuredWidth;
            state.lastContent = '';
        }
        if (state.resizeTimer !== null) {
            window.clearTimeout(state.resizeTimer);
        }
        state.resizeTimer = window.setTimeout(function () { return state.trigger(); }, resizeDebounce);
    };
    var onVisible = function () {
        if (document.visibilityState === 'visible') {
            state.trigger();
        }
    };
    if (document.readyState !== 'complete') {
        window.addEventListener('load', state.trigger, { once: true });
    }
    window.addEventListener('pageshow', state.trigger);
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    document.addEventListener('visibilitychange', onVisible);
    win.__danaViewportState__ = state;
    state.trigger();
}
export function getPlatform() {
    var platform = getArgFromUrl('platform');
    var ua = navigator.userAgent, isWindowsPhone = /(?:Windows Phone)/.test(ua), isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone, isAndroid = /(?:Android)/.test(ua), isFireFox = /(?:Firefox)/.test(ua), isChrome = /(?:Chrome|CriOS)/.test(ua), isTablet = /(?:iPad|PlayBook)/.test(ua) ||
        (isAndroid && !/(?:Mobile)/.test(ua)) ||
        (isFireFox && /(?:Tablet)/.test(ua)), isIPhone = (/(?:iPhone)/.test(ua) && !isTablet) || platform === 'iOS', isPc = !isIPhone && !isAndroid && !isSymbian;
    return {
        isTablet: isTablet,
        isIPhone: isIPhone,
        isAndroid: isAndroid,
        isPc: isPc,
        isChrome: isChrome,
    };
}
export function calculateWindow(num) {
    var platform = getPlatform();
    if (platform.isPc && !platform.isTablet) {
        return;
    }
    var width = window.screen.width;
    var height = Math.min(window.screen.height, window.innerHeight);
    if (height < 5) {
        setTimeout(function () {
            calculateWindow(num);
        }, 16);
        return;
    }
    var scale = Number((width / num).toFixed(3));
    var meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = "width=device-width,initial-scale=".concat(scale, ",user-scalable=no,maximum-scale=").concat(scale, ",minimum-scale=").concat(scale, ",viewport-fit=cover");
    document.documentElement.style.width = "".concat(num, "px");
    if (platform.isIPhone) {
        document.documentElement.style.height = '100vh';
    }
    else {
        document.documentElement.style.height = "".concat(window.innerHeight, "px");
    }
    // #
}
export function jumpToUserCard(uid) {
    console.log('11', uid);
    if (!uid) {
        return;
    }
    if (window.toFlutter) {
        window.toFlutter.postMessage(JSON.stringify({ method: 'openProfile', userId: uid }));
    }
}
export function formatMonth(m) {
    var year = m.getFullYear();
    var month = m.getMonth() + 1;
    return "".concat(year).concat(month < 10 ? '0' + month : month);
}
var flutterMessageTimer = null;
var postMessageToFlutter = function (reward) {
    if (flutterMessageTimer) {
        clearTimeout(flutterMessageTimer);
    }
    flutterMessageTimer = setTimeout(function () {
        try {
            if (window.toFlutter) {
                window.toFlutter.postMessage(JSON.stringify(__assign({ method: 'preview' }, reward)));
            }
        }
        catch (error) {
            console.error(error);
        }
    }, 300);
};
export function previewReward(reward) {
    postMessageToFlutter(reward);
}
export var goBack = function () {
    if (window.history.length > 1) {
        window.history.back();
    }
    else {
        window.toFlutter.postMessage(JSON.stringify({
            method: 'closeWebView',
        }));
    }
};
// static Map<num,List<Color>> colorMap = {
//     1:[const Color(0xffFF603B)],
//     2:[const Color(0xff3BA3FF)],
//     3:[const Color(0xffFFA73B)],
//     4:[const Color(0xff3BFF90)],
//     5:[const Color(0xffC43BFF)],
//     6:[const Color(0xff3B75FF),const Color(0xff3BD8FF)],
//     7:[const Color(0xffFF3B90),const Color(0xffFFCE3B)],
//     8:[const Color(0xffFF0000),const Color(0xffFFCE3B)],
//   };
/**
 * 兼容 Vite 和 Webpack 的资源加载函数
 * @param path 资源路径
 * @param callerImportMeta 调用方的 import.meta（可选，用于Vite环境）
 * @returns 返回一个获取资源URL的函数
 */
export var getAssetUrl = function (path, callerImportMeta) {
    return function () {
        // 检测是否为 Vite 环境
        if (typeof import.meta !== 'undefined' && import.meta.url) {
            // 优先使用调用方传入的 import.meta
            var metaToUse = callerImportMeta || import.meta;
            return new URL(path, metaToUse.url).href;
        }
        else {
            // Webpack 环境
            return require(path);
        }
    };
};
export var getVipColor = function (level) {
    var color = {
        1: '#FF603B',
        2: '#3BA3FF',
        3: '#FFA73B',
        4: '#3BFF90',
        5: '#C43BFF',
        6: ['#3B75FF', '#3BD8FF'],
        7: ['#FF3B90', '#FFCE3B'],
        8: ['#FF0000', '#FFCE3B'],
    };
    if (level <= 0) {
        return {};
    }
    if (level <= 5) {
        return { color: color[level] };
    }
    else {
        return {
            background: "linear-gradient(to right, ".concat(color[level][0], ", ").concat(color[level][1], ")"),
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
        };
    }
};
